import { alpha, styled } from "@mui/material/styles";
import SALE_TYPES from "../dictionaries/saleTypes.json";
import clsx from "clsx";

const SaleTypeIndicator = (props) => (
  <span
    className={clsx(props.className, {
      disabled: props.disabled,
      IsRefund: SALE_TYPES[props.value].isRefund,
      IsVoid: ["EV", "TV"].includes(props.value),
    })}
  >
    {props.value}
  </span>
);

export default styled(SaleTypeIndicator)(
  ({ theme }) => `
  background-color: ${alpha(theme.palette.background.paper, 0.75)};
  border: 1px solid ${theme.palette.primary.main};
  border-radius: 4px;
  color: ${theme.palette.primary.main};
  font-family: notosans-regular;
  font-weight: 700;
  font-size: 14px;
  height: 24px;
  width: 24px;
  line-height: 24px;
  text-align: center;
  position: relative;
  display: inline-block;

  &.disabled {
    border-color: ${theme.palette.grey["600"]};
    color: ${theme.palette.grey["600"]};
  }

  &.IsRefund {
    border-color: ${theme.palette.tertiary.main};
    color: ${theme.palette.tertiary.main};
  }

  &.IsVoid {
    border-color: ${theme.palette.grey["600"]};
    color: ${theme.palette.grey["600"]};
  }
`,
);
